import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

import type { ConnectionPlatformDisplay } from '../types.js';

interface Props {
  platform: ConnectionPlatformDisplay;
}

export const ConnectionExpiredAlert = ({ platform }: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  return (
    <Alert
      severity="warning"
      variant="multiline"
      removable={false}
      title={t('The connection has expired.')}
      description={t(
        'Please click on the "Reconnect {{platformLabel}} Account" button below.',
        { platformLabel: platform.label },
      )}
    />
  );
};
